export default __webpack_public_path__ + "static/media/delivery-truck.d53649fc.svg";